
<template>
    <div>
<!-- <h3>{{principal}}</h3>  -->
<v-snackbar
      v-model="mensaje.snackbar"
      :timeout="mensaje.timeout"
      :color="mensaje.color"
      text
      top
      right
    >
      {{ mensaje.text }}

      <template v-slot:action="{ attrs }">
<v-btn
          :color="mensaje.colorBtn"
          text
          v-bind="attrs"
          @click="mensaje.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <template>
  <v-card>
    <!-- <v-system-bar>para colocar rutas etc si se desea</v-system-bar> -->
    <v-toolbar flat>
      <v-toolbar-title>Listado de Perfiles Públicos</v-toolbar-title>
      
    </v-toolbar>


    



    <v-banner
      single-line
      :sticky="sticky"
      color="white"
    >
    

    <v-row>

<v-col cols="12" sm="12" md="8" lg="8">
  <v-text-field
            v-model="buscador" 
            placeholder="Ejemplo:Creador de contenido, emprendedor, vendedor, Electricista, Albañil, Marketing"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda por descripcion de perfiles
        </template>
          
          
          </v-text-field>

  
</v-col>



  <!--<v-col cols="12" sm="12" md="4" lg="4">

       <v-btn
          text
          color="deep-purple accent-4"
        >
          Get Online
        </v-btn>


    </v-col> -->


</v-row>

   

      
    </v-banner>



    <v-card-text class="">


      <v-sheet
        
        class="mx-auto"
      >
    

      
<!-- INICIO CARD -->


    <template>

     


<v-row>


  <v-col cols="12" sm="12"
  md="4"
  lg="4"
  v-for="principal in principalsDescripcionBuscados" :key="principal.codigo"
   v-if="!loading"
  >






  

<v-card
class="mx-auto"
max-width="400"
>
<v-img
class="white--text align-end"
contain
height="200px"

:src="server_url +'api/principal/get_image/'+principal.identificador+'/'+principal.linkPhoto"
>

</v-img> 

<v-card-title
style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
>{{principal.nombre}} {{principal.apellido}}


<v-icon v-if="principal.esRecomendado === 'verificado'" color="blue darken-2">
  mdi-check-circle-outline
</v-icon>


</v-card-title> 



<v-card-subtitle class="pb-0"
 style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
>
{{principal.descripcion}}
</v-card-subtitle>

<v-card-text class="text--primary">


<!-- ES POSIBLE AGREGAR TEXTO ADICIONAL -->
</v-card-text>

<v-card-actions>
<v-btn outlined text color="blue darken-4"
      @click="copiarUrl(principal.identificador)"
      >

      <v-icon>
 mdi-link
</v-icon> 
        Copiar URL
      </v-btn>

<v-btn
outlined text
  color="blue darken-4"
class="mr-4"

  @click="perfilOpen(principal.identificador)"
>
<v-icon>
 mdi-open-in-new
</v-icon> 
 Ver Perfil
</v-btn>

<v-spacer></v-spacer>

<v-btn icon @click="toggleExpand(principal.identificador)">
  <v-icon>{{ expandedId === principal.identificador ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
</v-btn>



</v-card-actions>


<v-expand-transition>
<div v-show="expandedId === principal.identificador">
  <v-divider></v-divider>

  <v-card-subtitle 
  :style="{
                fontSize: '15px',   /* Tamaño */
                fontWeight: '500',   /* Peso */
                letterSpacing: '-.015625em', /* Espaciado */
             /*   marginBottom: active ? '-1rem' : '0', /* Margen dinámico    grey--text en la parte de class de abajo*/
                color: '#78909C'
              }"
  >
  {{principal.descripcion}}
</v-card-subtitle>

  <v-card-text>
    <div>{{principal.observacion}}</div>
  </v-card-text>
</div>
</v-expand-transition>

</v-card>

  </v-col>




  <v-col cols="12" class="text-center" v-if="loading">
    <v-progress-circular indeterminate color="grey darken-3" size="64"></v-progress-circular>
  </v-col>



</v-row>
</template>

<!-- FIN NUEVO CARD  -->

    
    
    
    
    </v-sheet>
    </v-card-text>
  </v-card>
</template>










<!-- <td>{{principal.id}}</td>


<td>{{principal.nombre}}</td>


<td>{{principal.apellido}}</td>

<td>{{principal.identificador}}</td>



<td>{{principal.descripcion}}</td>


<td>{{principal.linkPhoto}}</td>


<td>{{principal.observacion}}</td>


<td>{{principal.linkVideo}}</td>-->















        




      
  
  </div>
</template>


<script>
import perfilesService from "@/services/perfilesService.js";

import axios from 'axios';

import { http } from "@/services/config";



export default {
     name: 'PerfilesView',
    
  components: {
  },
  computed: {
   
  },
    data: vm => ({

      sticky: true,
      loading: false,

      mensaje:{
          snackbar: false,
          text: '',
          color:'',
          timeout: -1,
      },
    
      server_url: "",
      expandedId: null,
    valid: true,
    buscador:'',
  principals: [],
  principal:{

id:'',
nombre:'',
apellido:'',
identificador:'',
descripcion:'',
linkPhoto:'',
observacion:'',
linkVideo:'',
zoom:50,
//color:'#FFFFFF', //COLOR POR DEFECTO
          
        },
rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
        
        
        
        
        
        
    
  }),
  created(){

       }
  ,mounted(){

    this.server_url = http.defaults.baseURL;

    console.log("Ingreseeee");
      this.listarPerfiles();
    
   
    },

  methods: {
    toggleExpand(id) {
      this.expandedId = this.expandedId === id ? null : id;
    },

    perfilOpen(identificador){

    
this.$router.push(`/perfil/`+identificador);


//const url = this.$router.resolve({ path: `/perfil/${identificador}` }).href;
//window.open(url, '_blank');


},
    listarPerfiles() {
      this.loading = true;

      perfilesService
        .listarPerfilesPublico()
        .then((resposta) => {
          console.log(resposta.data);
          this.principals = resposta.data.principal;
        }).finally(() => {
      this.loading = false;
    });
  
  },
    limpiar(){

     
		this.principal={
				id:'',
				id:0,
				nombre:'',
				apellido:'',
				descripcion:'',
				linkPhoto:'',
				observacion:'',
				linkVideo:'',
	}

        
    },
    copiarUrl(iden){

//let iden=localStorage.getItem("identificador");

const url = this.$router.resolve({ path: `/perfil/${iden}` }).href;

navigator.clipboard.writeText(window.location.origin+url)
.then(() => {


 

let mensajeText = 'URL copiada exitosamente';


  this.mensaje.text=mensajeText;

  this.mensaje.color="primary";
this.mensaje.colorBtn="blue";

this.mensaje.snackbar="true";


})
.catch(err => {
console.error('Error al copiar la URL:', err);
});




}


  },

    watch: {
      
    },
  computed:{
    

      principalsDescripcionBuscados() {
          return this.principals.filter(principal => {
            return principal.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      }
    
  
  },
};
</script>




